import { actions } from "./action";
import { adminsFirst } from "./adminsFirst";

const initialState = {
  tutors: [],
  archivedTutors: [],
  error: false,
  tutor: {},
  clubAdmins: [],
};

const tutorReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CREATE_TUTOR_SUCCESS:
      return {
        ...state,
        tutors: adminsFirst([...state.tutors, ...action.payload]),
      };

    case actions.GET_TUTORS_SUCCESS:
      return {
        ...state,
        tutors: action.payload.filter((tutor) => {
          return !tutor?.isDelete && tutor;
        }),
        archivedTutors: action.payload.filter((tutor) => {
          return tutor?.isDelete && tutor;
        }),
      };
    case actions.UPDATE_TUTOR_SUCCESS:
      return {
        ...state,
        tutor: action.payload,
        tutors: adminsFirst(
          state.tutors.map((tutor) =>
            tutor?.id === action.payload?.id ? action.payload : tutor
          )
        ),
      };

    case actions.REMOVE_TUTOR_SUCCESS:
      return {
        ...state,
        tutor: action.payload,
        tutors: state.tutors.filter((tutor) => {
          return tutor?.id !== action?.payload?.id && tutor;
        }),
        archivedTutors: [...state.archivedTutors, action.payload].sort((a, b) =>
          a?.name.localeCompare(b?.name)
        ),
      };

    case actions.UNREMOVE_TUTOR_SUCCESS:
      return {
        ...state,
        tutor: action.payload,
        tutors: [...state.tutors, action.payload].sort((a, b) =>
          a?.name.localeCompare(b?.name)
        ),
        archivedTutors: state.archivedTutors.filter((tutor) => {
          return tutor?.id !== action?.payload?.id && tutor;
        }),
      };

    case actions.DELETE_TUTOR_SUCCESS:
      return {
        ...state,
        tutors: adminsFirst(
          state.tutors.filter((data) => action?.payload !== data?.id)
        ),
        archivedTutors: state.archivedTutors.filter((tutor) => {
          return tutor?.id !== action?.payload;
        }),
      };

    case actions.GET_CLUB_ADMINS_SUCCESS:
      return {
        ...state,
        clubAdmins: action.payload,
      };

    case actions.CLEAR_TUTORS_STATE_SUCCESS:
      return {
        ...state,
        tutors: [],
        archivedTutors: [],
      };

    case actions.CATCH_ERROR:
      return {
        ...state,
        error: true,
      };
    default:
      return state;
  }
};

export default tutorReducer;
